import React, { useState } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../../Styles/DashboardStyle.module.css';
import DashboardTitle from "../DashboardTitle";
import DashBoardLeftProfileMenu from "../DashBoardLeftProfileMenu";
import { createBlogData,UpdatePostFormData } from "../../../services/routes.services";
import { useSelector } from 'react-redux';
import { Link,useNavigate ,useLocation} from 'react-router-dom';
import constants from "../../../services/constants";

const CreatePostListing = () => {
    const navigate = useNavigate();
  const location = useLocation();
     const postdata = location.state?.data || {};
    const [postTitle, setPostTitle] = useState(postdata.title || "");
    const [postContent, setPostContent] = useState(postdata.description || "");
    const [image, setImage] = useState(null);
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { isAuthenticated, user,token } = useSelector((state) => state.auth);
 
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        if (name === "postContent") {
            setPostContent(value);
        }
    };
    const handleInputtitleChange = (event) => {
        const { name, value } = event.target;
        if (name === "postTitle") {
            setPostTitle(value);
        }
    };
    const handleFileChange = (event) => {
        setImage(event.target.files[0]);
    };

    const validate = () => {
        let errors = {};
        if (!postContent) {
            errors.postContent = "Post content is required";
        }
        // if (!image) {
        //     errors.image = "Image is required";
        // }
        return errors;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const formErrors = validate();
        setErrors(formErrors);

        if (Object.keys(formErrors).length === 0) {
            setIsSubmitting(true);

            const formData = new FormData();
            formData.append("title", postTitle);
            formData.append("description", postContent);
            formData.append("image", image);
            formData.append("user", user._id);
             if(
                postdata &&
                ((typeof postdata === "object" && !Array.isArray(postdata) && Object.keys(postdata).length > 0) || // Non-empty object
                 (Array.isArray(postdata) && postdata.length > 0)) // Non-empty array
            ){
            if( postdata._id!=='undefined'){
           
                UpdatePostFormData(formData, postdata._id,token)
            .then(response => {
                if(response.data.success===true){
                  navigate("/postListing")
                }
                console.log("post update successfully", response);
            })
            .catch(error => {
                console.error("Error creating business", error);
            });
        }
            }
            else{
            try {
                const response = await createBlogData(formData,token);
                console.log("Post created successfully", response);
                navigate("/postListing");
                // You can add further actions here, such as resetting the form or displaying a success message
            } catch (error) {
                console.error("Error creating post", error);
            } finally {
                setIsSubmitting(false);
            }
        }
        }
    };

    return (
        <div>
            <DashBoardLeftProfileMenu />
            <div className={'containerStyla ' + Style.Dashboardscreen + " " + Style.BussinesList + " " + Style.postForm}>
                <Container>
                    <DashboardTitle title="Posts Listing" membertype="Non Member" />
                    <Row className={Style.space}>
                        <Col>
                            <div className={Style.newFormStyle}>
                                <h3 className={Style.dashboardSubTitle}>ADD POSTS DETAILS</h3>
                                <form id="myform" onSubmit={handleSubmit} noValidate>
                                    <div className={Style.formContainer}>
                                    <div className={Style.fromRow}>
                                            <div className={Style.fromCol2}>
                                                <label>Post Title</label>
                                                <textarea 
                                                    name="postTitle"
                                                    className={Style.inputStyle}
                                                    value={postTitle}
                                                    onChange={handleInputtitleChange}
                                                ></textarea>
                                                {errors.postContent && <p className={Style.error}>{errors.postContent}</p>}
                                            </div>
                                        </div>
                                        <div className={Style.fromRow}>
                                            <div className={Style.fromCol2}>
                                                <label>Post Description</label>
                                                <textarea 
                                                    name="postContent"
                                                    className={Style.inputStyle}
                                                    value={postContent}
                                                    onChange={handleInputChange}
                                                ></textarea>
                                                {errors.postContent && <p className={Style.error}>{errors.postContent}</p>}
                                            </div>
                                        </div>
                                        <div className={Style.fromRow}>
                                            <div className={Style.fromCol2}>
                                                <label>Image</label>
                                                <input 
                                                    type='file'
                                                    name="image"
                                                    className={Style.inputStyle + ' ' + Style.inputFileStyle}
                                                    onChange={handleFileChange}
                                                />
                                                {errors.image && <p className={Style.error}>{errors.image}</p>}
                                            </div>
                                        </div>
                                        <div className={Style.fromRow}>
                                            <div className={Style.fromCol2 + ' ' + Style.fromBtn}>
                                                <button type="submit" className={Style.subBtn} disabled={isSubmitting}>Submit</button>
                                                <button type="button" className={Style.clearBtn} onClick={() => {
                                                    setPostContent("");
                                                    setImage(null);
                                                    setErrors({});
                                                }}>Cancel</button>
                                            </div>
                                        </div>
                                    </div>              
                                </form>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default CreatePostListing;
